var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 67,
    viewBox: "0 0 100 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.658 0.0586664C15.4714 0.0586664 0.6875 14.8426 0.6875 33.0292C0.6875 51.2158 15.4714 65.9997 33.658 65.9997V0V0.0586664Z",
    fill: "url(#paint0_linear_524_47279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6875 32.9999C33.6875 14.7646 48.4521 0 66.6874 0C84.9226 0 99.6872 14.7646 99.6872 32.9999C99.6872 41.4558 96.5123 49.1655 91.2888 55.0027H99.6872V66.0026H88.6873V57.6039C82.8504 62.8259 75.1419 65.9997 66.6874 65.9997C48.4521 65.9997 33.6875 51.2351 33.6875 32.9999Z",
    fill: "url(#paint1_linear_524_47279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_47279",
    x1: 17.1728,
    y1: 0,
    x2: 17.1728,
    y2: 65.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4945FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_47279",
    x1: 66.6874,
    y1: 0,
    x2: 66.6874,
    y2: 66.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4945FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqLogo);
export default __webpack_public_path__ + "static/media/CQLogo.6fdc6d4808a32c505d2c0ec430ab4363.svg";
export { ForwardRef as ReactComponent };